<template>
  <base-dialog class="change-parent-dialog" width="485px" :visible.sync="visible" show-close>
    <template v-slot:header>
      更改父任务
    </template>
    <el-form label-width="90px">
      <el-form-item>
        <template v-slot:label>
          父任务
          <el-tooltip placement="bottom-start">
            <template v-slot:content>
              若更改的任务仅包含子任务，更改后将保留原父子关系；
              <br />
              若更改的任务包含孙子任务，则无法添加父任务。
            </template>
            <span class="icon-tip pointer">
              <i class="el-icon-info"></i>
            </span>
          </el-tooltip>
        </template>
        <div class="select-parent">
          <div :class="['left', disabled ? 'disabled' : '']">
            <div class="is-text">
              {{ parent.name || "请选择" }}
              <span v-if="parent.name" class="icon-close">
                <i class="el-icon-close" @click="changeParent({})"></i>
              </span>
            </div>
          </div>
          <div class="right" :class="{ 'is-disabled': disabled }" @click="openRefDialog">
            <i class="el-icon-plus"></i>
          </div>
        </div>
      </el-form-item>
    </el-form>
    <template v-slot:footer>
      <base-button @click="visible = false">取消</base-button>
      <base-button type="primary" @click="submit">确认</base-button>
    </template>
    <parent-table
      :project-id="projectId"
      :task-group="taskGroup"
      :task-level="levelForParent"
      :task-ids="selectedTaskIdsForParent"
      :dialog-visible.sync="parentTableVisible"
      @select="changeParent"
    ></parent-table>
  </base-dialog>
</template>

<script>
import BaseDialog from "@/components/BaseComponents/Dialog"
import BaseButton from "@/components/UIComponents/Button"
import ParentTable from "@/components/Task/EditDialog/ParentTable"
import { getChildrenIds, getTaskLevel } from "@/utils/project"

export default {
  name: "ChangeParentDialog",
  components: { BaseButton, BaseDialog, ParentTable },
  props: {
    projectId: String,
    taskGroup: Object,
    selectedTasks: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: false,
      parent: {},
      selectedTaskIdsForParent: [],
      levelForParent: null,
      parentTableVisible: false,
      disabled: false
    }
  },
  methods: {
    open() {
      let taskIds = []
      this.parent = {}
      this.disabled = false
      // 获取所有子任务id
      this.selectedTasks.forEach(selectedTask => {
        getChildrenIds(selectedTask, taskIds)
      })

      // 计算层级
      this.levelForParent = getTaskLevel(this.selectedTasks) - 1
      if (this.levelForParent >= 3) {
        this.disabled = true
      }
      this.selectedTaskIdsForParent = this.selectedTasks
        .filter(task => !taskIds.includes(task.id))
        .map(task => task.id)
      this.visible = true
    },
    openRefDialog() {
      if (this.disabled) return
      this.parentTableVisible = true
    },
    changeParent(val) {
      this.parent = val
    },
    submit() {
      this.$emit("select", { taskIds: this.selectedTaskIdsForParent, selectedVal: this.parent })
      this.visible = false
    }
  }
}
</script>

<style lang="scss" scoped>
.change-parent-dialog {
  .el-form {
    margin-top: 18px;
  }
  .icon-tip {
    margin-left: 4px;
    font-size: 16px;
    &:hover {
      color: #3aacf8;
    }
  }
  .select-parent {
    display: flex;
    align-items: center;
    height: 40px;
    .left {
      &.disabled {
        background-color: #f5f7fa;
        border-color: #e4e7ed;
        color: #c0c4cc;
        cursor: not-allowed;
      }
      flex: auto;
      .is-text {
        @include ellipsis;
        position: relative;
        height: 32px;
        line-height: 32px;
        padding-left: 11px;
        padding-right: 24px;
        border-radius: 4px 0 0 4px;
        border: 1px solid #d8dce6;
        box-sizing: border-box;
        color: $color-main;

        .icon-close {
          position: absolute;
          right: 2px;
          color: $color-font-second;

          .el-icon-close {
            padding: 4px;
            cursor: pointer;

            &:hover {
              color: $color-main;
            }
          }
        }
      }
    }

    .right {
      @include flex-center;
      min-width: 32px;
      height: 32px;
      background: $color-bg-select;
      border-radius: 0px 4px 4px 0px;
      border: 1px solid #d8dce6;
      border-left-width: 0;
      cursor: pointer;
      box-sizing: border-box;

      &:hover:not(.is-disabled) {
        color: $color-main;
      }
    }
  }
}
</style>
